import React from 'react';
import { connect } from "react-redux";
import { Col } from 'react-bootstrap';
import NumberBox from './NumberBox';
import { Unit, roundOfAcres } from '../../../helpers/unit';
import { HARVESTING_PLAN_TYPE_ID } from '../../../constants';

const NumberBoxList = (props) => {
    const { analyseDetails, selectedPlanTypeId, fieldLoadsById, settings: { areaShortName } } = props;
    const unit = Unit.getInstance();
    const { summary, elasticWork, elasticLoad } = analyseDetails;

    const plannedAcres = summary && summary.acres && summary.acres.planned ? unit.toRoundOfArea(summary.acres.planned) : 0;
    const completedAcres = summary && summary.acres && summary.acres.completed ? unit.toRoundOfArea(summary.acres.completed) : 0;
    const remainingAcres = (plannedAcres > completedAcres) ? roundOfAcres(plannedAcres - completedAcres) : 0;

    const NumberBoxList = [
        {
            id: 0, name: `Planned ${areaShortName}`, primaryColor: '#5d6a8d66', isRequesting: summary && summary.isRequesting,
            value: plannedAcres
        },
        {
            id: 1, name: "Completed", primaryColor: '#3c685f66',
            isRequesting: (summary && summary.isRequesting) || (elasticWork && elasticWork.isRequesting),
            value: completedAcres
        },
        {
            id: 2, name: "Remaining", primaryColor: '#777a4e66',
            isRequesting: (summary && summary.isRequesting) || (elasticWork && elasticWork.isRequesting),
            value: remainingAcres
        },
        {
            id: 3, name: "Loads", primaryColor: '#70737966',
            isRequesting: (elasticLoad && elasticLoad.isRequesting) || fieldLoadsById.isRequesting,
            value: summary && summary.load ? summary.load.totalLoads : 0,
            subValue: summary && summary.load && summary.load.loadWeight
                ? unit.formatNumber(unit.toRoundOfWeight(summary.load.loadWeight))
                : 0
        }
    ];

    return NumberBoxList.filter(item => !(selectedPlanTypeId !== HARVESTING_PLAN_TYPE_ID && item.id === 3)).map(item => {
        return <Col className="p-0" key={item.id}>
            <NumberBox item={item} />
        </Col>
    })
}

const mapStateToProps = state => {
    const selectedPlanTypeId = state.farmMonitor.selectedPlanTypeId;
    return ({
        selectedPlanTypeId,
        analyseDetails: state.farmMonitor.summaryByPlanTypeId[selectedPlanTypeId] ? state.farmMonitor.summaryByPlanTypeId[selectedPlanTypeId] : {},
        fieldLoadsById: state.farmMonitor.fieldLoadsById,
        settings: {
            areaShortName: state.user.settings.areaShortName
        }
    });
}

export default connect(mapStateToProps)(NumberBoxList);